import React from 'react';

interface ExperienceSectionProps {
  jobs: Array<{
    organization: {
      name: string;
      image?: {
        link: string;
        alt: string;
      };
    };
    roles: Array<{
      name: string;
      startDate: string;
      finishDate: string;
      challenges?: Array<{
        description: string;
      }>;
      competences?: Array<{
        name: string;
        type: string;
      }>;
    }>;
  }>;
}

const ExperienceSection: React.FC<ExperienceSectionProps> = ({ jobs }) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return 'Presente';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', { year: 'numeric' });
  };

  const getAllTechnologies = (competences: any[]) => {
    // Mostrar TODAS las tecnologías sin filtros
    return competences || [];
  };

  return (
    <div className="timeline-container">
      {jobs.map((job: any, jobIndex: number) => (
        <div key={jobIndex} className="job-item-simple">
          {job.roles.map((role: any, roleIndex: number) => (
            <div key={roleIndex} className="timeline-item">
              <div className="timeline-point"></div>
              <div className="timeline-content">
                <div className="role-header-simple">
                  <div className="role-info-inline">
                    {job.organization.image && (
                      <img 
                        src={job.organization.image.link} 
                        alt={job.organization.image.alt}
                        className="company-logo-inline"
                      />
                    )}
                    <div className="role-details-inline">
                      <h4 className="role-title-inline">{role.name}</h4>
                      <span className="company-separator">en</span>
                      <h5 className="company-name-inline">{job.organization.name}</h5>
                    </div>
                  </div>
                  <span className="role-dates-simple">
                    {formatDate(role.startDate)} - {formatDate(role.finishDate)}
                  </span>
                </div>
              
              {/* Descripción completa respetando saltos de línea */}
              {role.challenges && role.challenges[0] && (
                <div className="role-description-simple">
                  {role.challenges[0].description.split('\n').map((line: string, lineIndex: number) => (
                    <p key={lineIndex} style={{ margin: '0 0 8px 0' }}>
                      {line}
                    </p>
                  ))}
                </div>
              )}
              
              {/* Tecnologías - TODAS sin filtros */}
              {role.competences && getAllTechnologies(role.competences).length > 0 && (
                <div className="tech-tags-simple">
                  {getAllTechnologies(role.competences).map((competence: any, compIndex: number) => (
                    <span key={compIndex} className="tech-tag-simple">
                      {competence.name}
                    </span>
                  ))}
                </div>
              )}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ExperienceSection;